import { Button, Card, Col, Collapse, ConfigProvider, QRCode, Row, Select, Space, Typography, Breadcrumb } from "antd";
import axios from "axios";
import dayjs from 'dayjs'
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { client_id, url } from "../login/setting";
import { HomeOutlined } from "@ant-design/icons";
const QRcodePunch = ({

}) => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const { PatrolLocationId, GradeClassId } = useParams()
    const [classManagement, setClassManagement] = useState([])
    const [patrolLocation, setPatrolLocation] = useState([])
    const [state, setState] = useState()
    const [value, setValue] = useState()
    const [orderType, setOrderType] = useState("ascend")
    const [gradeClass, setGradeClass] = useState([])
    const nowDay = dayjs().format('YYYY/MM/DD')
    const punchRecordTimeout = useRef()
    const punch_type_id = 1
    const punchRecordCheckedAllow = useRef(true)
    const [currentTime, setCurrenTime] = useState(dayjs().format('YYYY-MM-DD HH:mm:ss'));

    const getPatrolRecord = () => {
        axios
            .get('/cramSchool/api/grade_class_student_staff_class_record', {
                params: {
                    grade_class_id: GradeClassId,
                    only_date: dayjs().format('YYYY-MM-DD'),
                    student: 'true',
                    order: [
                        JSON.stringify({
                            // column: "abs_gap",
                            // type: orderType
                            column: "roll_call_status",
                            type: orderType
                        })
                    ]
                }
            })
            .then(response => {
                if (punchRecordCheckedAllow.current) {
                    setCurrenTime(dayjs().format('YYYY-MM-DD HH:mm:ss'))
                    setClassManagement(response.data?.data ?? [])
                }
            })
            .finally(() => {
                clearTimeout(punchRecordTimeout.current)
                punchRecordTimeout.current = setTimeout(getPatrolRecord, 1000)
            })
    }
    const getPatrolLocation = () => {
        axios
            .get('/hrms/api/patrol_location', {
                params: {
                    patrol_location_id: PatrolLocationId
                }
            })
            .then(response => {
                setPatrolLocation(response.data.data)
                const value = ((response.data.data || []).find(_ => true)?.patrol_location_punch_data || []).find(find_item => find_item.punch_type_id === punch_type_id)?.patrol_location_punch_value
                const state = encodeURIComponent(JSON.stringify({
                    service: `/cramSchool/PunchReservation/${value}/${GradeClassId}`,
                    state: value
                }))
                console.log(value)
                setValue(value)
                setState(state)
            })
    }

    const onRefresh = (record) => {
        axios
            .post('/hrms/api/patrol_location_punch', [
                {
                    ...record,
                    patrol_location_punch_value: Date.now(),
                    punch_type_id
                }
            ])
            .then(response => {
                getPatrolLocation()
            })
    }
    const downloadQRCode = () => {
        const canvas = document.getElementById('myqrcode')?.querySelector('canvas');
        if (canvas) {
            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = 'QRCode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };
    const getGradeClass = () => {
        axios
            .get('/cramSchool/api/grade_class', {
                params: {
                    grade_class_id: GradeClassId
                }
            })
            .then(response => {
                setGradeClass(response.data)
            })
    }
    useEffect(() => {
        getGradeClass()
        getPatrolRecord()
        getPatrolLocation()
        return () => {
            clearTimeout(punchRecordTimeout.current)
        }
    }, [])
    return (<ConfigProvider
        theme={{
            token: {
                fontSize: 18
            },
        }}>
        <Row style={{
            padding: "2vw"
        }}>
            <Col span={24}>
                <Row justify={'space-between'}>
                    <Col>
                        <Typography.Title level={2}>QR Code打卡簽到</Typography.Title>
                    </Col>
                    <Col span={24}>
                        <Row
                            justify={"space-between"}
                        >
                            <Col>
                                <Breadcrumb
                                    items={[
                                        {
                                            href: '/cramSchool/admin/punchInAndOut/LocationData',
                                            title: <HomeOutlined />,
                                        },
                                        {
                                            href: '',
                                            title: (
                                                <>
                                                    <span>QR Code打卡簽到</span>
                                                </>
                                            ),
                                        },
                                    ]}
                                />
                            </Col>
                            <Col>最後更新時間：{currentTime}</Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Row gutter={[24, 8]}>
                    <Col
                        span={12}
                    >
                        <Card
                            bodyStyle={{
                                textAlign: '-webkit-center'
                            }}
                        >
                            <Row>
                                <Col span={24}>
                                    <Row justify={"end"}>
                                        <Col>
                                            <Space>
                                                <Button
                                                    style={{
                                                        height: '100%',
                                                        borderRadius: 36,
                                                        fontSize: '1rem',
                                                        fontWeight: 600,
                                                        backgroundColor: "rgb(254,207,109)",
                                                        boxShadow: "0px 2px 0px 0px #00000040"
                                                    }}
                                                    onClick={() => onRefresh(patrolLocation.find(_ => true))}
                                                >
                                                    <Space direction={'vertical'}>
                                                        <span>刷新</span>
                                                        <span>QR Code</span>
                                                    </Space>
                                                </Button>
                                                <Button
                                                    style={{
                                                        height: '100%',
                                                        borderRadius: 36,
                                                        fontSize: '1rem',
                                                        fontWeight: 600,
                                                        backgroundColor: "rgb(189,249,207)",
                                                        boxShadow: "0px 2px 0px 0px #00000040"
                                                    }}
                                                    onClick={downloadQRCode}
                                                >
                                                    <Space direction={'vertical'}>
                                                        <span>下載</span>
                                                        <span>QR Code</span>
                                                    </Space>
                                                </Button>
                                            </Space>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24}>
                                    <Typography.Title level={3}>打卡簽到</Typography.Title>
                                </Col>
                                <Col span={24}>
                                    {value && <div id="myqrcode">
                                        <QRCode
                                            size={240}
                                            bgColor="#fff"
                                            value={
                                                'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=' +
                                                client_id + '&redirect_uri=' + url + '&state=' + state +
                                                '&scope=profile%20openid&nonce=' + value
                                            }
                                        // status="expired"
                                        // onRefresh={() => console.log('refresh')}
                                        />
                                    </div>}
                                </Col>
                            </Row>


                        </Card>
                    </Col>
                    {/* <Col span={GradeClassId ? 8 : 12}>
                        <Card
                            title={'尚未2次打卡'}
                            headStyle={{
                                backgroundColor: "rgb(233,247,255)"
                            }}
                            style={{
                                padding: 0,
                                margin: 0
                            }}
                        >
                            <Space
                                direction={'vertical'}
                                size={0}
                            >
                                {classManagement.filter(filter_item => !(filter_item.punch_record_id)).map(map_item => {
                                    const department_name = (map_item?.deparment_role_data || []).map(map_item => {
                                        return map_item.department_language_data.find(find_item => find_item.language_culture_code === language)?.language_culture_value || ''
                                    }).join(',')

                                    return (<>
                                        <Space
                                            style={{
                                                paddingLeft: '2rem'
                                            }}
                                        >
                                            <span>{department_name}</span>
                                            <span>{map_item.serial_name || (map_item.user_id + '號')}</span>
                                            <Typography.Link style={{ color: 'rgb(92,153,185)' }}>{map_item.staff_name || map_item.student_name}</Typography.Link>
                                        </Space>
                                    </>)
                                })}
                            </Space>
                        </Card>
                    </Col> */}
                    <Col span={12}>
                        <Card
                            headStyle={{
                                backgroundColor: "rgb(244,232,254)",
                                border: '0px'
                            }}
                            title={'打卡時間'}
                            extra={<>
                                <Select
                                    onChange={(e) => setOrderType(e)}
                                    defaultValue={'ascend'}
                                    options={[
                                        { label: '到達時間由近-遠', value: 'ascend' },
                                        { label: '到達時間由遠-近', value: 'descend' }
                                    ]}
                                />
                            </>}
                        >
                            {/* {console.log(classManagement)} */}
                            {classManagement
                                .filter(filter_item => (filter_item.staff_class_record_id))
                                .map(map_item => {
                                    const department_name = (map_item?.deparment_role_data || []).map(map_item => {
                                        return map_item.department_language_data.find(find_item => find_item.language_culture_code === language)?.language_culture_value || ''
                                    }).join(',')

                                    return (<>
                                        <Space
                                            style={{
                                                paddingLeft: '2rem'
                                            }}
                                        >
                                            {/* <span>{dayjs(map_item?.date).format('HH:mm')}</span> */}
                                            <span>{department_name}</span>
                                            <span>{map_item.serial_name || (map_item.user_id + '號')}</span>
                                            <Typography.Link style={{ color: map_item.gap > 0 ? 'rgb(92,153,185)' : 'rgb(171,74,70)' }}>{map_item.staff_name || map_item.student_name
                                                // }{map_item.gap > 0 ? `(剩${map_item.gap}分)` : `(逾期${(map_item.gap * -1)}分)`
                                            }</Typography.Link>
                                        </Space>
                                    </>)
                                })}
                        </Card>
                    </Col>
                    {/* <Col span={GradeClassId ? 8 : 12}>
                        <Card
                            headStyle={{
                                backgroundColor: "rgb(253,244,232)",
                                border: '0px'
                            }}
                            bodyStyle={{
                                maxHeight: '40vh',
                                overflow: 'scroll'
                            }}
                            title={'已2次打卡'}
                            extra={<>
                                <Select
                                    onChange={(e) => setOrderType(e)}
                                    defaultValue={'ascend'}
                                    options={[
                                        { label: '到達時間由近-遠', value: 'ascend' },
                                        { label: '到達時間由遠-近', value: 'descend' }
                                    ]}
                                />
                            </>}
                        >
                            <Space
                                direction={'vertical'}
                                size={0}
                            >
                                {classManagement.filter(filter_item => filter_item.punch_record_id).map(map_item => {
                                    const department_name = (map_item?.deparment_role_data || []).map(map_item => {
                                        return map_item.department_language_data.find(find_item => find_item.language_culture_code === language)?.language_culture_value || ''
                                    }).join(',')

                                    return (<>
                                        <Space
                                            style={{
                                                paddingLeft: '2rem'
                                            }}
                                        >
                                            <span>{dayjs(map_item.punch_record_time).format('HH:mm')}</span>
                                            <span>{department_name}</span>
                                            <span>{map_item.serial_name || (map_item.user_id + '號')}</span>
                                            <Typography.Link style={{ color: 'rgb(92,153,185)' }}>{map_item.staff_name || map_item.student_name}</Typography.Link>
                                        </Space>
                                    </>)
                                })}
                            </Space>
                        </Card>
                    </Col> */}
                </Row>
            </Col>
        </Row>


    </ConfigProvider>)
}
export default QRcodePunch;